import * as React from 'react';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

// ErrorBoundary component
class ErrorBoundary extends React.PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {

    state: ErrorBoundaryState = { hasError: false };

    constructor(props: ErrorBoundaryProps) {
        super(props);
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        // Display fallback UI
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div>
                // error message
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary